// extracted by mini-css-extract-plugin
module.exports = {"article-description":"Articles_article-description__OvUev","hidden-subsection-title":"Articles_hidden-subsection-title__q6gRn"};